import React from "react";
import PropTypes from 'prop-types';
import CONST from "../../config/CONST";
import RadioButtonCustomer from "../RadioButtonCustomer/RadioButtonCustomer";

const CustomerSelection = (props) => {

    const {
        customer,
        value,
        onChange,
        checked
    } = props;

    return (
        <>
            <div className={`${CONST.CSS_NAMESPACE}CustomerSelection`}>
                <RadioButtonCustomer
                    onCheck={(clicked) => onChange(customer.typeOfCustomer, clicked)}
                    defaultChecked={checked}
                    value={value}
                    customer={customer}
                />
            </div>
        </>
    )
}

CustomerSelection.propTypes = {
    customer: PropTypes.object.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired
}

export default CustomerSelection;